import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProductDetailsComponent } from './../product-details/product-details.component';
import { ConfirmCartProductComponent } from '../confirm-cart-product/confirm-cart-product.component';
import { ProductComponent } from './product.component';
import { MatButtonModule } from '@angular/material/button';
import { VariationsModule } from '../variations/variations.module';
import { RedirectModule } from '../redirect/redirect.module';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { CarouselModule } from 'primeng/carousel';
import { ReviewFormComponent } from './../reviewForm/reviewForm.component';
import { ReviewDesktopComponent } from '../review-desktop/review-desktop.component';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { AllReviewsDesktopComponent } from '../all-reviews-desktop/all-reviews-desktop.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GalleryModule } from '@ngx-gallery/core';
import { OwlModule } from 'ngx-owl-carousel';
import { ProductFeaturesComponent } from '../product-details/product-features/product-features.component';
import { ProductItemsCarouselComponent } from '../product-details/product-items-carousel/product-items-carousel.component';
import { ProductUpgradesComponent } from '../product-details/product-upgrades/product-upgrades.component';
import { ProductReviewsComponent } from '../product-details/product-reviews/product-reviews.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProductCollectionComponent } from './product-collection/product-collection.component';
import { ImageArrangePipe } from '../product-details/image-arrange.pipe';
import { MarkdownModule } from 'ngx-markdown';
import { ProductFeaturesNewComponent } from '../product-details/product-features-new/product-features-new.component';
import { ProductPreviewPanelComponent } from '../product-preview-panel/product-preview-panel.component';
import { UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from 'src/app/shared/custom-url-serializer';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

const DECLARATIONS = [
    ProductComponent,
    ProductDetailsComponent,
    ReviewFormComponent,
    ConfirmCartProductComponent,
    ReviewDesktopComponent,
    AllReviewsDesktopComponent,
    ProductFeaturesComponent,
    ProductFeaturesNewComponent,
    ProductItemsCarouselComponent,
    ProductUpgradesComponent,
    ProductReviewsComponent,
    ProductCollectionComponent,
    ImageArrangePipe
];

const MODULES = [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    VariationsModule,
    RedirectModule,
    MatSelectModule,
    FormsModule,
    SharedModule, 
    MarkdownModule.forRoot(),
    NgxMatSelectSearchModule,
    ReactiveFormsModule,

];

const COMPONENTS = [
    ProductDetailsComponent,
    ProductPreviewPanelComponent,
    ConfirmCartProductComponent,
    ReviewFormComponent,
    ReviewDesktopComponent,
    AllReviewsDesktopComponent,
    ProductCollectionComponent,

];

@NgModule({
    declarations: [...DECLARATIONS,ProductPreviewPanelComponent],
    entryComponents: [...COMPONENTS],
    imports: [...MODULES, CarouselModule, LightboxModule, InfiniteScrollModule, GalleryModule, OwlModule,
        
    ],
    // providers:[         { provide: UrlSerializer, useClass: CustomUrlSerializer }
    // ],
    exports: [...DECLARATIONS,  CommonModule,
        MatCardModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        VariationsModule,
        RedirectModule,
        MatSelectModule,
        FormsModule,
        ProductPreviewPanelComponent,
        SharedModule, ]
})
export class ProductModule {
}
